<template>
  <b-card-code title="جدول البحوث" no-body>
    <b-card-body>
      <div class="d-flex justify-content-between flex-wrap">
        <!-- filter -->
        <b-form-group
          label="فلتر البحث"
          label-cols-sm="2"
          label-align-sm="left"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="md">
            <b-form-input
              id="filterInput"
              v-model="filter"
              type="search"
              placeholder="ابحث عن .."
            />
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">
                الغاء الفلتر
              </b-button>
              <b-button v-if="role"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                v-b-modal.model-a-w
              >
                <feather-icon icon="FilePlusIcon" class="mr-50" />
                <span class="align-middle">اضافة بحث جديد</span>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
    </b-card-body>
<div class="demo-vertical-spacing">
      <b-progress
      v-if="precentage !== 0"
        :value="precentage"
        max="100"
      />
      </div>
    <b-table
      ref="table"
      striped
      hover
      responsive
      class="position-relative"
      :per-page="perPage"
      :items="items"
      :fields="fields"
    >
      <template #cell(action)="action">
        <b-dropdown
          variant="link"
          no-caret
          :right="$store.state.appConfig.isRTL"
        >
          <template #button-content>
            <feather-icon
              icon="MoreVerticalIcon"
              size="16"
              class="align-middle text-body"
            />
          </template>
          <b-col md="12" v-if="role">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-success"
              v-b-modal.model-e-w
              @click="eRM(action.item)"
            >
              <feather-icon icon="EditIcon" class="mr-50" />
              <span class="align-middle">تعديل</span>
            </b-button>
          </b-col>
          <b-col md="12" v-if="role">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-danger"
              v-b-modal.modal-center
              @click="dRM(action.item)"
            >
              <feather-icon icon="Trash2Icon" class="mr-50" />
              <span class="align-middle">حذف</span>
            </b-button>
          </b-col>
        </b-dropdown>
      </template>
      <template #cell(link)="link">
        <b-button v-if="link"
          v-ripple.400="'rgba(0, 207, 232, 0.15)'"
          variant="outline-info"
          @click="onClicked(link.item)"
        >
          عرض البحث
        </b-button>
        <span v-else class="align-middle">NO file</span>
      </template>
    </b-table>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <!-- page length -->
      <b-form-group
        label="Per Page"
        label-cols="6"
        label-align="left"
        label-size="sm"
        label-for="sortBySelect"
        class="text-nowrap mb-md-0 mr-1"
      >
        <b-form-select
          id="perPageSelect"
          v-model="perPage"
          @change="check()"
          size="sm"
          inline
          :options="pageOptions"
        />
      </b-form-group>

      <!-- pagination -->
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
        class="mb-0"
        @change="check()"
      >
        <template #prev-text>
          <feather-icon icon="ChevronLeftIcon" size="18" />
        </template>
        <template #next-text>
          <feather-icon icon="ChevronRightIcon" size="18" />
        </template>
      </b-pagination>
    </b-card-body>
    <b-modal
      id="model-e-w"
      ok-title="حفظ التعديلات"
      centered
      size="lg"
      title="تعديل معلومات البحث"
      @show="checkModel"
      @ok="updateResearch"
      @hidden="resetCheckboxes"
    >
      <b-form novalidate class="needs-validation">
        <b-form-row>
          <b-col md="12">
            <label for="input-valid1">عنوان البحث:</label>
            <b-form-input
              id="input-valid1"
              v-model="editform.en_title"
              :state="editform.en_title.length > 0"
              placeholder="عنوان البحث كما مذكور في البحث"
            />
          </b-col>

          <b-col md="12">
            <label for="input-invalid1">المجلة العملية او المؤتمر:</label>
            <b-form-input
              id="input-invalid1"
              v-model="editform.magazine"
              :state="editform.magazine.length > 0"
              placeholder="المجلة العملية او المؤتمر"
            />
          </b-col>
          <b-col md="12">
            <label for="input-valid1">الرابط:</label>
            <b-form-input
              id="input-valid1"
              v-model="editform.link"
              :state="editform.link.length > 0"
              placeholder="رابط البحث المنشور"
            />
          </b-col>
          <b-col md="12">
            <label for="input-invalid2">تاريخ النشر:</label>
            <b-form-input
              id="input-invalid2"
              v-model="editform.publish_date"
              :state="editform.publish_date.length > 0"
              placeholder="تاريخ النشر"
            />
          </b-col>
          <b-col md="12" v-if="role&&canSelect">
            <b-form-group>
              <label for="basic-password">اختر الاكاديمي الناشر</label>
              <v-select
                v-model="editform.teacher_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :options="teachers"
                placeholder="اختر الاكاديمي الناشر"
              />
            </b-form-group>
          </b-col>
          <b-form-group label="">
          <div class="demo-inline-spacing">
      <b-form-checkbox
        v-model="editform.is_sustainabilty"
        value="1"
      >
      البحث له علاقة بالتنمية المستدامة
      </b-form-checkbox>
      <b-form-checkbox
        v-model="editform.is_energy"
        value="1"
      >
      البحث له علاقة بالطاقة المستدامة
      </b-form-checkbox>
    </div>
          </b-form-group>
        </b-form-row>
      </b-form>
    </b-modal>
    <b-modal
      id="model-a-w"
      ok-title="حفظ البيانات"
      centered
      size="lg"
      title="اضافة بحث جديد"
      @show="checkModel"
      @ok="aNR"
      @hidden="resetCheckboxes"
    >
      <b-form novalidate class="needs-validation">
        <b-form-row>
          <b-col md="12">
            <label for="input-valid1">عنوان البحث:</label>
            <b-form-input
              id="input-valid1"
              v-model="form.en_title"
              :state="form.en_title.length > 0"
              placeholder="عنوان البحث كما مذكور في البحث"
            />
          </b-col>

          <b-col md="12">
            <label for="input-invalid1">المجلة العملية او المؤتمر:</label>
            <b-form-input
              id="input-invalid1"
              v-model="form.magazine"
              :state="form.magazine.length > 0"
              placeholder="المجلة العملية او المؤتمر"
            />
          </b-col>
          <b-col md="12">
            <label for="input-valid1">الرابط :</label>
            <b-form-input
              id="input-valid1"
              v-model="form.link"
              :state="form.link.length > 0"
              placeholder="رابط البحث المنشور"
            />
          </b-col>
          <b-col md="12">
            <label for="input-invalid2">تاريخ النشر:</label>
            <b-form-input
              id="input-invalid2"
              v-model="form.publish_date"
              :state="form.publish_date.length > 0"
              placeholder="تاريخ النشر"
            />
          </b-col>
          
          <b-col md="12"  v-if="role&&canSelect">
            <b-form-group>
              <label for="basic-password">اختر الاكاديمي الناشر</label>
              <v-select
                v-model="form.teacher_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :options="teachers"
                placeholder="اختر الاكاديمي الناشر"
              />
            </b-form-group>
          </b-col>
          <b-form-group label="">
          <div class="demo-inline-spacing">
      <b-form-checkbox
        v-model="form.is_sustainabilty"
        value="1"
      >
        البحث له علاقة بالتنمية المستدامة
      </b-form-checkbox>
      <b-form-checkbox
        v-model="form.is_energy"
        value="1"
      >
      البحث له علاقة بالطاقة المستدامة
      </b-form-checkbox>
    </div>
          </b-form-group>
        </b-form-row>
      </b-form>
    </b-modal>
    <b-modal
      id="modal-center"
      centered
      title="حذف البحث"
      @ok="deleteResearch"
      ok-title="حذف البيانات"
    >
      <b-card-text>
      هل تريد حذف هذه الحقل " {{this.editform.en_title}} " ?
      </b-card-text>
    </b-modal>
  </b-card-code>
</template>

<script>
import vSelect from "vue-select";
import store from "@/store";
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import {
  BTable,
  BAvatar,
  BModal,
  BDropdown,
  BDropdownItem,
  BFormCheckboxGroup,
  BForm,
  BFormRow,
  BCol,
  VBModal,
  BBadge,
  BFormValidFeedback,
  BFormInvalidFeedback,
  BFormGroup,
  BFormCheckbox,
  BCardText,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,BProgress,
  BButton,
  BCardBody,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BCardCode,
    BTable,
    BForm,
    BAvatar,
    BBadge,
    BFormRow,
    BDropdown,
    BDropdownItem,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormCheckboxGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BModal,
    VBModal,
    Ripple,
    BCol,
    BFormCheckbox,BProgress,
    BCardText,
    BFormValidFeedback,vSelect,
    BFormInvalidFeedback,
  },
  data() {
    return {
      teacher_id: "",
      perPage: 3,
      precentage:0,
      role:null,
      canSelect:false,
      pageOptions: [3, 5, 10, 100],
      totalRows: 1,
      currentPage: 0,
      filter: "",
      filterOn: [],
      departments: [],
      teachers: [],
      fields: [
        {
          key: "en_title",
          label: "عنوان البحث",
        },
        {
          key: "magazine",
          label: "المجلة او المؤتمر",
        },
        { key: "link", label: "الرابط " },
        { key: "publish_date", label: "تاريخ النشر" },
        { key: "action", label: "الاجراءات" },
      ],
      items: [],
      notifi: {
        route: "",
        title: "",
        item_id: "",
        table: "",
        users: [],
        departments: [],
        role_id: "",
        type: "",
        subtitle: "",
        bg: "",
      },
      form: {
        en_title: "",
        magazine: "",
        link: "",
        publish_date: "",
        teacher_id: "",
        is_sustainabilty: 0,
        is_energy: 0,
      },
      editform: {
        en_title: "",
        magazine: "",
        link: "",
        publish_date: "",
        teacher_id: "",
        is_sustainabilty: 0,
        is_energy: 0,
        id: null
      },
      selected: [],
    };
  },
   watch: {
    filter: function (val) {
      if (val == null) {
        this.filter = null
      }
      this.gS();
    },
    "$route.params.id": {
      handler: function (search) {
        this.gS();
      },
    },
  },
  computed: {},
  directives: {
    Ripple,
  },
  mounted() {
    if(localStorage.getItem("NisourRole")=="admin"||localStorage.getItem("NisourRole")=="teacher"){
      this.role = true
    }else{
            this.role = false
    }
    if(localStorage.getItem("NisourRole")=="admin"){
      this.canSelect = true
    }else{
      this.canSelect = false
    }
    this.ID(), this.gS(),this.gSM1()
  },
  methods: {
    
    async gSM1() {
      this.teachers = []
      this.editform.teacher_id==""
      await this.axios
        .get(`teachers-name`)
        .then((res) => {
          this.teachers = [];
          this.teachers = res.data.items;
        })
        .catch((e) => {
          if (e.message.includes("401")) {
            this.makeToast(
              "danger",
              "update failed",
              "you don't a permision to do this action ;)"
            );
          } else {
            this.errorToast();
          }
        });
    },
    checkModel() {
      this.selected = [];
      if (this.editform.is_sustainabilty == 1) {
        this.selected.push("is_sustainabilty");
      }
      if (this.editform.is_energy == 1) {
        this.selected.push("is_energy");
      }
    },
    resetCheckboxes() {
      this.selected = [];
    },
    async updateResearch() {
      if (this.selected.length > 0) {
        if (this.selected.includes("is_sustainabilty")) {
          this.editform.is_sustainabilty = 1;
        }
        if (this.selected.includes("is_energy")) {
          this.editform.is_energy = 1;
        }
      }
      await this.axios
        .post(`research/${this.editform.id}`,this.editform,{
          onUploadProgress: progressEvent => {
            this.precentage =
              (progressEvent.loaded / progressEvent.total) * 100;
          }
        })
        .then((res) => {
          if(res.data.errors){
            this.errorToast()
          }else{
          this.gS()
        this.makeToast(
            "success",
            "update Success",
            "Your update is done successfully"
          );
          this.notifi.route = "researches-notif";
            this.notifi.title = "update action";
            this.notifi.item_id = res.data.data.id;
            this.notifi.table = "researches";
            this.notifi.role_id = 1;
            this.notifi.type = "light-worning";
            this.notifi.subtitle = "updated a research";
            this.notifi.bg = "bg-worning";
            this.sendNoti();
          }
          this.rEF()
this.precentage =0
        })
        .catch((e) => {
          if(e.message.includes("401") ){
            this.makeToast(
            "warning",
            "update failed",
            "you don't a permision to do this action ;)"
          );
          }else{
            this.errorToast()
          }
          this.rEF()
        });
        
    },
    rF(){
      this.form.en_title= "",
      this.form.magazine= "",
      this.form.link= "",
      this.form.publish_date=""
      this.form.teacher_id=""
      this.form.is_sustainabilty=""
      this.form.is_energy=""
    },
    rEF(){
      this.editform.en_title= "",
      this.editform.magazine= "",
      this.editform.link= "",
      this.editform.publish_date=""
      this.editform.teacher_id=""
      this.editform.is_sustainabilty=""
      this.editform.is_energy=""
      this.editform.id=""
    },
    async aNR(){
            if (this.selected.length > 0) {
        if (this.selected.includes("is_sustainabilty")) {
          this.form.is_sustainabilty = 1;
        }
        if (this.selected.includes("is_energy")) {
          this.form.is_energy = 1;
        }
      }
      this.form.teacher_id = this.teacher_id;
      await this.axios
        .post(`research`,this.form,{
          onUploadProgress: progressEvent => {
            this.precentage =
              (progressEvent.loaded / progressEvent.total) * 100;
          }
        })
        .then((res) => {
          if(res.data.errors){
            this.errorToast()
          }else{
          this.gS()
        this.makeToast(
            "success",
            "update Success",
            "Your update is done successfully"
          );
          this.notifi.route = "researches-notif";
            this.notifi.title = "add action";
            this.notifi.item_id = res.data.data.id;
            this.notifi.table = "researches";
            this.notifi.role_id = 1;
            this.notifi.type = "light-Success";
            this.notifi.subtitle = "added new research";
            this.notifi.bg = "bg-success";
            this.sendNoti();
          }
          this.rF()
          this.precentage =0
        })
        .catch((e) => {
          if(e.message.includes("401") ){
            this.makeToast(
            "warning",
            "update failed",
            "you don't a permision to do this action ;)"
          );
          }else{
            this.errorToast()
          }
        });
          this.rF()
    },
    async sendNoti() {
      await this.axios.post(`notifications`, this.notifi);
    },
    async deleteResearch(){
await this.axios
        .delete(`research/${this.editform.id}`)
        .then((res) => {
          if(res.data.errors){
            this.errorToast()
          }else{
          this.gS()
        this.makeToast(
            "success",
            "Delete Success",
            "Your item is deleted successfully"
          );
            this.notifi.route = "researches-notif";
            this.notifi.title = "delete action";
            this.notifi.item_id = res.data.data.id;
            this.notifi.table = "researches";
            this.notifi.role_id = 1;
            this.notifi.type = "light-danger";
            this.notifi.subtitle = "deleted research";
            this.notifi.bg = "bg-danger";
            this.sendNoti();

          }
        })
        .catch((e) => {
          if(e.message.includes("401") ){
            this.makeToast(
            "warning",
            "update failed",
            "you don't a permision to do this action ;)"
          );
          }else{
            this.errorToast()
          }
        });
    },
    errorToast(){
this.makeToast(
            "danger",
            "update failed",
            "some thing want wrong, i`m sorry :(")
    },
     eRM(item) {
      this.editform.en_title = item.en_title;
      this.editform.magazine = item.magazine;
      this.editform.link = item.link;
      this.editform.publish_date = item.publish_date;
      this.editform.teacher_id = item.teacher_id;
      this.editform.is_sustainabilty = item.is_sustainabilty;
      this.editform.is_energy = item.is_energy;
      this.editform.id = item.id;
    },
    dRM(item){
      this.editform.en_title = item.en_title;
      this.editform.id = item.id;
    },
    check() {
      setTimeout(() => this.gS(), 1000);
    },
    ID() {
      this.teacher_id = localStorage.getItem("NisourTeacherId");
    },
async gS(){
        await this.axios
        .get(
          `research?take=${this.perPage}&skip=${
            this.currentPage - 1
          }&teacher_id=${this.teacher_id}&search=${this.filter}
          &show=${this.$route.params.id}`
        )
        .then((res) => {
          this.items = []
          this.totalRows = res.data.totalCount;
          this.items = res.data.items;
        })
        .catch((e) => {
          if(e.message.includes("401") ){
            this.makeToast(
            "danger",
            "update failed",
            "you don't a permision to do this action ;)"
          );
          }else{
            this.errorToast()
          }
        });

},
    async gR() {
      await this.axios
        .get(
          `research?take=${this.perPage}&skip=${
            this.currentPage - 1
          }&teacher_id=${this.teacher_id}`
        )
        .then((res) => {
          this.items = []
          this.totalRows = res.data.totalCount;
          this.items = res.data.items;
        })
        .catch((e) => {
          console.log(e);
          console.log("error");
        });
    },
    makeToast(variant = null, title = null, body = null) {
      this.$bvToast.toast(body, {
        title: title,
        variant,
        solid: false,
      });
    },
    onClicked(path) {
      window.open(`${path.link}`, "_blank");
      // window.open(`${filesUrl}/${path}`, "_blank");
    },
  },
  
};
</script>
